
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as my_45coursesYyY7sF_hng6lN8rL8bBZ5XNgn_JoFe7DT2cE3c2e79kMeta } from "/Users/sitech/PycharmProjects/portal/individual-frontend/pages/ar/individuals/my-courses.vue?macro=true";
import { default as check_certificatecFUjoOA_uYBSj6b5eW8AxpevN_YRcm9Xd6mZ_tlmWawMeta } from "/Users/sitech/PycharmProjects/portal/individual-frontend/pages/ar/individuals/check_certificate.vue?macro=true";
import { default as _91uuid_935EOSKhAJhvC4Cpu8G4mT4zeEVfsq6ReTxpmSobb1cEMMeta } from "/Users/sitech/PycharmProjects/portal/individual-frontend/pages/ar/individuals/program-details-view/[uuid].vue?macro=true";
export default [
  {
    name: "ar-individuals-my-courses",
    path: "/ar/individuals/my-courses",
    component: () => import("/Users/sitech/PycharmProjects/portal/individual-frontend/pages/ar/individuals/my-courses.vue")
  },
  {
    name: "ar-individuals-check_certificate",
    path: "/ar/individuals/check_certificate",
    component: () => import("/Users/sitech/PycharmProjects/portal/individual-frontend/pages/ar/individuals/check_certificate.vue")
  },
  {
    name: "ar-individuals-program-details-view-uuid",
    path: "/ar/individuals/program-details-view/:uuid()",
    component: () => import("/Users/sitech/PycharmProjects/portal/individual-frontend/pages/ar/individuals/program-details-view/[uuid].vue")
  }
]